import Header from '../home/components/Header';
import Footer from '../home/components/Footer';
import { useNavigate } from 'react-router-dom';

export default function LegalNoticePage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main className="pt-32 pb-24">
        <div className="container mx-auto px-6 max-w-4xl">
          <div className="flex items-center justify-between mb-6">
            <h1 className="text-4xl lg:text-5xl font-bold text-gray-900">
              Aviso Legal
            </h1>
            <button
              onClick={() => navigate('/')}
              className="flex items-center gap-2 bg-emerald-600 text-white px-6 py-3 rounded-lg hover:bg-emerald-700 transition-colors font-medium whitespace-nowrap cursor-pointer"
            >
              <i className="ri-arrow-left-line"></i>
              Volver al inicio
            </button>
          </div>
          <p className="text-gray-600 mb-12">Última actualización: {new Date().toLocaleDateString('es-ES')}</p>

          <div className="prose prose-lg max-w-none space-y-8">
            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">1. Datos Identificativos</h2>
              <div className="bg-emerald-50 p-6 rounded-lg space-y-2">
                <p className="text-gray-700"><strong>Denominación social:</strong> PROTECPLUS INGENIERÍA</p>
                <p className="text-gray-700"><strong>Domicilio social:</strong> Avenida de Madrid, 86 Nave 3 - 28500 Arganda del Rey, Madrid, España</p>
                <p className="text-gray-700"><strong>Email:</strong> info@protecplus.es</p>
                <p className="text-gray-700"><strong>Teléfono:</strong> +34 900 123 456</p>
                <p className="text-gray-700"><strong>Horario de atención:</strong> Lunes a Viernes de 7:00 a 15:00</p>
              </div>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">2. Objeto</h2>
              <p className="text-gray-700 leading-relaxed">
                El presente aviso legal regula el uso y utilización del sitio web de PROTECPLUS INGENIERÍA, del que es titular la empresa anteriormente identificada. La navegación por el sitio web atribuye la condición de usuario del mismo e implica la aceptación plena y sin reservas de todas y cada una de las disposiciones incluidas en este Aviso Legal.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">3. Servicios</h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                A través de este sitio web, PROTECPLUS INGENIERÍA facilita a los usuarios información sobre sus servicios profesionales, que incluyen:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-gray-700">
                <li>Dirección de obra de protección contra incendios</li>
                <li>Servicios de ingeniería especializada</li>
                <li>Medición de gas radón y su mitigación</li>
                <li>Calibración e instalación de detectores de gases</li>
                <li>Formación profesional en incendios, megafonía y seguridad empresarial</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">4. Responsabilidad</h2>
              <p className="text-gray-700 leading-relaxed mb-4">
                PROTECPLUS INGENIERÍA no se hace responsable de:
              </p>
              <ul className="list-disc pl-6 space-y-2 text-gray-700">
                <li>La continuidad y disponibilidad de los contenidos del sitio web</li>
                <li>La ausencia de errores en dichos contenidos ni la corrección de cualquier defecto que pudiera ocurrir</li>
                <li>La ausencia de virus y/o demás componentes dañinos en el sitio web o en el servidor que lo suministra</li>
                <li>La invulnerabilidad del sitio web y/o la inexpugnabilidad de las medidas de seguridad adoptadas</li>
                <li>Los daños o perjuicios que cause cualquier persona que vulnere los sistemas de seguridad</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">5. Propiedad Intelectual e Industrial</h2>
              <p className="text-gray-700 leading-relaxed">
                Todos los contenidos del sitio web, salvo que se indique lo contrario, son titularidad exclusiva de PROTECPLUS INGENIERÍA y, en particular, el diseño gráfico, código fuente, logos, textos, gráficos, ilustraciones, fotografías y demás elementos que aparecen en el sitio web. Igualmente, todos los nombres comerciales, marcas o signos distintivos de cualquier clase contenidos en el sitio web están protegidos por la Ley de Propiedad Intelectual e Industrial.
              </p>
              <p className="text-gray-700 leading-relaxed mt-4">
                Queda prohibida la reproducción, distribución, comunicación pública, transformación o cualquier otra actividad que se pueda realizar con los contenidos del sitio web sin la autorización previa y por escrito de PROTECPLUS INGENIERÍA.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">6. Protección de Datos</h2>
              <p className="text-gray-700 leading-relaxed">
                PROTECPLUS INGENIERÍA cumple con las directrices del Reglamento General de Protección de Datos (RGPD) y la Ley Orgánica de Protección de Datos y Garantía de los Derechos Digitales (LOPDGDD). Para más información, consulte nuestra <a href="/politica-proteccion-datos" className="text-emerald-600 hover:underline">Política de Protección de Datos</a>.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">7. Cookies</h2>
              <p className="text-gray-700 leading-relaxed">
                Este sitio web utiliza cookies propias y de terceros para mejorar la experiencia de navegación y ofrecer contenidos de interés. Si continúa navegando, consideramos que acepta su uso. Puede obtener más información sobre las cookies, o bien conocer cómo cambiar la configuración, en nuestra política de cookies.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">8. Enlaces</h2>
              <p className="text-gray-700 leading-relaxed">
                En el caso de que en el sitio web se dispusiesen enlaces o hipervínculos hacia otros sitios de Internet, PROTECPLUS INGENIERÍA no ejercerá ningún tipo de control sobre dichos sitios y contenidos. En ningún caso asumirá responsabilidad alguna por los contenidos de algún enlace perteneciente a un sitio web ajeno.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">9. Modificaciones</h2>
              <p className="text-gray-700 leading-relaxed">
                PROTECPLUS INGENIERÍA se reserva el derecho de efectuar sin previo aviso las modificaciones que considere oportunas en su sitio web, pudiendo cambiar, suprimir o añadir tanto los contenidos y servicios que se presten a través de la misma como la forma en la que éstos aparezcan presentados o localizados.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">10. Legislación Aplicable</h2>
              <p className="text-gray-700 leading-relaxed">
                Las presentes condiciones se rigen por la legislación española. Para cualquier controversia que pudiera derivarse del acceso o uso del sitio web, PROTECPLUS INGENIERÍA y el usuario acuerdan someterse a los Juzgados y Tribunales de Madrid, renunciando expresamente a cualquier otro fuero que pudiera corresponderles.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">11. Contacto</h2>
              <p className="text-gray-700 leading-relaxed">
                Para cualquier consulta relacionada con este aviso legal, puede contactar con nosotros a través de:
              </p>
              <div className="bg-gray-50 p-6 rounded-lg mt-4 space-y-2">
                <p className="text-gray-700"><strong>Email:</strong> info@protecplus.es</p>
                <p className="text-gray-700"><strong>Teléfono:</strong> +34 900 123 456</p>
                <p className="text-gray-700"><strong>Dirección:</strong> Avenida de Madrid, 86 Nave 3 - 28500 Arganda del Rey, Madrid</p>
              </div>
            </section>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
